/// <reference path="../Entity/User.ts" />
/// <reference path="../Repository/User.ts" />
namespace HA.Core.Service {
    import UserEntity = HA.Core.Entity.User;
    import UserRepository = HA.Core.Repository.User;

    export class User extends Service {

        /**
         *
         * @param data
         * @returns {Promise<void>}
         */
        public login(data: Map<string, any>) {
            const me = this;
            return this.getUserRepository().findByCredencial(data).then((response: Map<string, any>) => {

                if (response.get("success")) {
                    const profile = toMap(response.get("profile"));
                    me.updateUser(profile);
                    me.reloadNav();
                    return response.get("profile");
                } else {
                    return Promise.reject(toMap(response));
                }
            });
        }

        /**
         *
         * @param data
         * @returns {Promise<void>}
         */
        public loginFB(data: Map<string, any>) {
            const me = this;
            me.getPageService().removeApp("ha.user.menu");
            return this.getUserRepository().findByCredencial(data).then((response: Map<string, any>) => {
                if (response.get("success")) {
                    const profile = toMap(response.get("profile"));
                    me.updateUser(profile);

                    if (profile.has("greet")) {
                        notifyUser(toMap(profile.get("greet")));
                    }
                    timeout(() => {
                        me.reloadNav();
                        me.loadUserPreferedApp();
                    }, 100);
                    return response.get("profile");
                } else {
                    return Promise.reject(toMap(response));
                }
            });
        }

        public subscribe(func: (i:any) => void) {
            const s: Map<any, any> = this.get("subscribers");
            if (s) {
                s.set(s.size, func);
                func(this.getUser().getProfileData());
            }
        }

        public getUser(): UserEntity {
            return this.get("user");
        }

        /**
         *
         * @returns {UserEntity}
         */
        public getUserRepository() {
            return this.get("userRepository");
        }

        /**
         *
         * @param data
         */
        public process(data: Map<any, any>) {
            switch (data.get("a")) {
                case "logout" :
                    this.logout();
                    break;
                case "refresh" :
                    this.updateUserProfile();
                    break;
            }
        }

        protected loadUserPreferedApp() {
            this.getPageService().reloadApp(toMap({id: "main"}));
        }

        protected reloadNav() {
            this.getPageService().reloadNav();
        }

        protected notifySubscribers() {
            const s: Map<any, any> = this.get("subscribers");
            const me = this;
            if (s) {
                s.forEach((func) => {
                    func(me.getUser().getProfileData());
                });
            }
        }

        /**
         *
         * @param data
         */
        protected updateUser(data: any) {
            this.getUser().update(data);
            this.notifySubscribers();
        }

        protected logout() {
            const me = this;
            return this.request(toMap({url: "/user/logout", data: {}})).then((response: Map<any, any>) => {
                const cookies = document.cookie.split(";");

                cookies.forEach((cookie: any) => {
                    const eqPos = cookie.indexOf("=");
                    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";

                });

                me.getPageService().removeAll();
                me.updateUserProfile();
                getAppService().processAction(response);

            });

        }

        /**
         * @returns {IWebPageService}
         */
        protected getPageService() {
            return this.getService("ha.service.webpage");
        }

        /**
         *
         * @param data
         * @returns {Promise<T>}
         */
        protected request(data: Map<any, any>) {
            return this.getRouter().post(data);
        }

        /**
         *
         * @returns {HA.Core.Service.HARouter}
         */
        protected getRouter() {
            return this.getService("router");
        }

        /**
         *
         * @returns {Promise<void>}
         */
        protected updateUserProfile() {
            const me = this;
            const data = new Map();
            return this.getUserRepository().getUserProfile(data).then(
                (response: Map<string, any>) => {
                    if (response.get("extra")) {
                        getAppService().processAction(toMap(response.get("extra")));
                    }
                    if (response.get("success")) {
                        const uData = toMap(response.get("profile"));
                        me.updateUser(uData);
                    } else {
                        return Promise.reject(response);
                    }
                });
        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.addToData("userRepository", new UserRepository(data));
            this.addToData("user", new UserEntity());
            this.addToData("subscribers", new Map());

            this.updateUserProfile();
        }
    }
}
